import { isObject } from 'Helpers/objects';

export const isHomePage = ({ location, urlKeywords }) => {
    const urlKeywordsRegex = urlKeywords ? new RegExp(`${Object.values(urlKeywords).join('|')}`) : '';

    return isObject(location)
        && (location?.pathname === '/' || location.pathname === '/olxmobbi'
        || (!!urlKeywordsRegex && urlKeywordsRegex.test(location?.pathname)));
};
